import $ from 'jquery';

const selectors = {
  anchor: 'data-sticky-anchor'
};

export class StickyElement {
  constructor($element) {
    this.$stickyElement = $element;
    this.$anchorElement = this.getAnchor();

    this.position = {};
    this.state = 'unstick';
  }

  getAnchor() {
    const src = this.$stickyElement.data('sticky-src');

    return $(`[${selectors.anchor}=${src}]`);
  }

  init() {
    this.$stickyElement.css({
      width: this.$stickyElement.width(),
      height: this.$stickyElement.height()
    });
    this.$stickyElement.parent().css({
      position: 'relative',
      height: this.$anchorElement.outerHeight()
    });

    this.position = {
      topOffset: this.$anchorElement.offset().top,
      stickElementHeight: this.$stickyElement.outerHeight(),
      anchorElementHeight: this.$anchorElement.outerHeight()
    };
  }

  emit(nextState) {
    if (this.state !== nextState) {
      this.state = nextState;

      if (nextState === 'unstick') {
        this.unstick();
      }

      if (nextState === 'top') {
        this.stickToTop();
      }

      if (nextState === 'bottom') {
        this.stickToBottom();
      }
    }
  }

  stickToTop() {
    this.$stickyElement.css({
      position: 'fixed',
      top: 0,
      bottom: ''
    });
  }

  stickToBottom() {
    this.$stickyElement.css({
      position: 'absolute',
      top: '',
      bottom: 0
    });
  }

  unstick() {
    this.$stickyElement.css({ position: '' });
  }

  isStickyElementSmallerThanAnchor() {
    return this.$stickyElement.height() < this.$anchorElement.height();
  }
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-shared/layout/sticky-overview/sticky-element.js
 **/